export default __webpack_public_path__ + "static/media/logo1.46556185.jpg";